<template>
<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
<div class="collabsable-section">
    <div class="section-title clickable-header" @click="toggleExpanded()">
        <div class="model-3d"></div>
        <div style="flex-grow: 1;font-size: 17px;">Levels &amp; Areas</div>
        <div style="color: gray;" :class="['expand-collapse-ico','fas',!isExpanded?'fa-caret-down':'fa-caret-up']"></div>
    </div>
    <div v-if="isExpanded" class="expanded-section">
        <div style="text-align: end;padding: 3px 10px;">
            <input type="text" v-virtual-keyboard v-model="searchtext" style="width: 25%;" placeholder="Search..." />
        </div>
        <div v-for="level in shownLevels" :key="level.id">
            <div class="model-row" @click="showPlanView(level)">
                <input type="radio" class="model-version-checkbox" style="margin-right:5px;" :value="level.name" v-model="selectedLevelName" @change="mainLevelCheckboxChecked()" @click.stop="" />
                <b style="padding-left: 5px;flex-grow:1;">{{level.name}}</b>


                <div style="display:flex;" @click.stop="" title="Open in 3D">
                    <CustomCheckbox 
                        :is_checked="level.openIn3D" 
                        :name="'openIn3D'"
                        @check_changed="toggleOpenIn3D(level,$event)">
                    </CustomCheckbox>
                </div>
                <div class="level-dbids" :style="{'background-color':level.dbidsList.length>0 ? 'green':'lightgray' }">{{level.dbidsList.length}} Objects</div>
                <div class="btn-hover-orange fas fa-cube" style="position: relative;" @click.stop="ShowIn3D(level)" title="Show in 3D">
                    <div v-if="level.isShowingIn3D" class="fas fa-slash" style="position: absolute;left: 5px;top: 5px;"></div>
                </div>
                <div class="btn-hover-orange fas fa-upload" @click.stop="uploadLevelPlan(level)" title="Upload Level Plan"></div>
                <input type="file" :id="'uploadLevelPlanInput'+level.id" style="display:none;" accept="image/*, application/pdf" @click.stop="" @change="onSelectImage($event,level)" />

                <div class="btn-hover-orange fas fa-pen" @click.stop="editLevel(level)" title="Edit Level"></div>
                <div class="btn-hover-orange fas fa-trash" @click.stop="deleteLevel(level)" title="Delete Level"></div>
            </div>
            <progress style="width: 100%;height: 20px;" v-if="level.isUploading"></progress>
        </div>
        <div class="info-section" style="align-items: center;flex-direction: row;">
            <div class="admin-btn" style="margin-right: 7px;" @click="addLevel()">Add Level</div>
        </div>
    </div>
</div>
</template>

<script>
import HttpService from '../../../utils/httpService';
import { toggleExpandComponent, getEditLevelComponent } from '../../../scripts/js/forgeviewer'
import { ForgeLevel } from '../../../scripts/js/forgeModels'
import { saveLevels, editType } from '../../../utils/mongoUtils'
import { checkIsModelTrasnlated } from '../../../utils/forgeUtils'
import $ from 'jquery';

export default {
    name: 'AdminLevels',
    components: {
        CustomCheckbox: () => import('@/components/common/customCheckbox.vue'),
    },
    emits: ['toggle-level-in-3d', 'launch-viewer', 'update_levels'],
    data() {
        return {
            isExpanded: false,
            searchtext: '',
            selectedLevelName: this.$store.state.levels.find(o => o.isSelected) ? this.$store.state.levels.find(o => o.isSelected).name : '',
        }
    },
    watch: {
        levels: function () {
            this.selectedLevelName = this.$store.state.levels.find(o => o.isSelected) ? this.$store.state.levels.find(o => o.isSelected).name : '';
        }
    },
    props: ['levels', 'assetid'],
    methods: {
        toggleOpenIn3D(level, $event) {
            level.openIn3D = $event.value;
            saveLevels(level, editType.EDIT_LEVEL);
        },
        mainLevelCheckboxChecked() {
            this.$store.state.levels.forEach(o => {
                if (o.name != this.selectedLevelName)
                    o.isSelected = false;
                else {
                    o.isSelected = true;
                    this.$store.state.forgeService.saveSelectedLevel(this.assetid, o.name);
                }
            });
        },
        toggleExpanded() {
            toggleExpandComponent(this);
        },
        ShowIn3D(level) {
            if (!level.planImageUrl) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Old data found, please upload the plan again.' })
                return;
            }
            this.$emit('toggle-level-in-3d', level);
        },
        showPlanView(level, callback) {
            if (!level.planUrn) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please upload a plot plan first.' })
                return;
            }
            if (!level.planImageUrl) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Old data found, please upload the plan again.' })
                return;
            }
            var _this = this;
            checkIsModelTrasnlated(level.planUrn, (isTranslated) => {
                if (!isTranslated) {
                    this.$store.dispatch({ type: "alert_Forge", message: 'Plot plan not yet translated, please wait.' })
                    return;
                }
                if (isTranslated) {
                    _this.$emit('launch-viewer', level);
                    if (callback)
                        callback()
                }
            });
        },
        uploadLevelPlan(level) {
            if (level.isUploading) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please wait until uploading is done.' })
                return;
            }
            if (!level) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please select a level first.' })
                return;
            }
            $('#uploadLevelPlanInput' + level.id).click();
        },
        onSelectImage(event, level) {
            var file = event.target.files[0];
            let formData = new FormData();
            formData.append("fileToUpload", file);
            formData.append("assetId", this.assetid);
            formData.append("levelId", level.id);
            formData.append("oldUrn", level.planUrn);
            formData.append("oldImage", level.planImageUrl);
            $('#uploadLevelPlanInput' + level.id).val('');

            level.isUploading = true;
            HttpService.post({
                url: 'api/levels/uploadLevelPlan',
                data: formData,
                headers: {
                    'Content-Type' : false,
                    'processData': false,
                },
            }).then((response) => {
                let { data } = response;
                level.isUploading = false;
                level.planUrn = data.planUrn;
                level.planImageUrl = data.planImageUrl;
            }).catch((err) => {
                level.isUploading = false;
                this.$store.dispatch({ type: "alert_Forge", message: err })
            })
        },
        deleteLevel(level) {
            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'Are you sure you want to delete level?', callback: () => {
                    saveLevels(level, editType.DELETE_LEVEL);
                    var index = this.levels.findIndex(o => o == level);
                    this.$emit('update_levels', this.levels.slice(0, index).concat(this.levels.slice(index + 1)));
                }
            })
        },
        addLevel() {
            // TODO: REFACTOR
            var level = new ForgeLevel();
            level.isExpanded = true;
            level.name = 'New Level';
            getEditLevelComponent().level = level;
            getEditLevelComponent().isediting = false;
            $('#editLevelModal').css('display', 'flex');
        },
        editLevel(level) {
            // TODO: REFACTOR
            getEditLevelComponent().sourceLevel = level;
            getEditLevelComponent().level = level.clone();
            getEditLevelComponent().isediting = true;
            $('#editLevelModal').css('display', 'flex');
        },
    },
    computed: {
        shownLevels: function () {
            let lower = this.searchtext.toLowerCase();
            return this.levels.filter(o => o.name.toLowerCase().includes(lower) || lower.includes(o.name.toLowerCase()));
        },
    },
}
</script>

<style>
.model-3d {
    background-size: cover;
    background-image: url(../../../images/3d-black.png);
    width: 23px;
    height: 23px;
    margin-right: 10px;
}

.level-dbids {
    width: auto;
    margin: 5px;
    border-radius: 5px;
    color: white;
    font-size: 13px;
    padding: 1px 5px;
}
</style>
